import { Value } from "./firebaseUtil";

const schema = {
  ["public-messages"]: {
    $eventSlug: {
      muted: {
        $eventUserId: Value(),
      },
      url: {
        $pageSlug: {
          messages: {
            $firebaseID: Value(),
          },
        },
      },
    },
  },
  ["private-messages"]: {
    ["user-inboxes"]: {
      $eventUserId: {
        $inboxUUID: {
          isArchived: Value(),
        },
      },
    },
    inboxes: {
      $inboxUUID: {
        settings: {
          videoroom: Value(),
          members: {
            $eventUserId: Value(),
          },
        },
        messages: {
          $firebaseID: Value(),
        },
      },
    },
  },
  ["corporate-messages"]: {
    $organizationSlug: {
      $eventSlug: {
        inboxes: {
          $pageSlug: {
            $eventUserId: {
              settings: {
                videoroom: Value(),
                latestActivity: Value(),
                agent: {
                  lastActive: Value(),
                  tabTitle: Value(),
                },
                client: {
                  lastActive: Value(),
                  availability: Value(),
                },
              },
              messages: {
                $firebaseID: Value(),
              },
            },
          },
        },
        settings: {
          public: {
            ["initial-message"]: {
              message: Value(),
              offlineMessage: Value(),
              isEnabled: Value(),
              online: Value(),
              chatTitle: Value(),
            },
          },
          private: {
            agents: {
              $agentId: {
                displayName: Value(),
                title: Value(),
                latestActivity: Value(),
                availability: Value(),
              },
            },
          },
        },
        availability: {
          $pageSlug: {
            $eventUserId: {
              client: {
                isBusy: Value(),
                availability: Value(),
              },
            },
          },
        },
        pages: {
          $pageSlug: {
            $eventUserId: {
              settings: {
                claimedBy: Value(),
                isTrashed: Value(),
                latestActivity: Value(),
              },
            },
          },
        },
      },
    },
  },
  ["speed-meeting"]: {
    $eventSlug: {
      $pageSlug: {
        $eventUserId: {
          redirect_url: Value(),
        },
      },
    },
  },
  $eventSlug: {
    announcements: {
      private: {
        $uuid: {
          results: Value(),
        },
      },
      public: {
        results: Value(),
      },
    },
  },
  statistics: {
    $eventSlug: {
      $pageSlug: {
        $eventUserId: Value(),
      },
    },
  },
};

export default schema;
